module.exports = __webpack_public_path__ + "static/media/smartwords-app_2screen.0b0bff11.png";